import {NewRedemptionData, Redemption} from "types/Redemption";
import client from "services/ngage/api-client";
import deserializeRedemption from "services/ngage/deserializers/redemption";
import {AxiosError} from "axios";
import {ApiError, ClientError} from "services/ngage/error";

/**
 * Store a new redemption
 *
 * @param data
 */
const store = async (data: NewRedemptionData) => {
    try {
        const redemption = (await client.post<Redemption | ApiError | null>('/redemptions', data)).data
        return redemption ? deserializeRedemption(redemption) : null
    } catch (e) {
        const error = e as AxiosError

        // Handle expired vouchers, etc.
        if(error.isAxiosError && error.response?.status === 409) {
            const responseData = error.response.data as any
            const message = responseData.message ?? ''

            return {message} as ClientError
        }

        console.error("Unable to store redemption", error)
        return null
    }
}

const redemptions = {
    store
}

export default redemptions